import { FC } from 'react'
import { SvgProps } from './svgProps'

const EmailIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    width={width || '30'}
    height={height || '30'}
    viewBox="0 0 400 219"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.5741 0H368.426C377.099 0 384.986 2.83665 390.71 7.41189L390.75 7.44371C396.459 12.019 400 18.3248 400 25.2593V192.968C400 199.906 396.454 206.216 390.735 210.795L390.695 210.827C384.976 215.394 377.094 218.227 368.426 218.227H31.5741C22.8812 218.227 14.9789 215.386 9.26485 210.815C3.55078 206.244 0 199.922 0 192.968V25.2593C0 18.3049 3.55078 11.9831 9.26485 7.41189C14.9789 2.84063 22.8812 0 31.5741 0ZM373.3 207.616L253.826 112.038L202.056 150.215C199.639 152.001 195.915 152.029 193.488 150.243L141.728 111.994L23.4183 206.638C25.8899 207.588 28.6599 208.122 31.5741 208.122H368.426C370.112 208.122 371.743 207.947 373.3 207.616ZM263.121 105.183L383.847 201.764C386.065 199.281 387.368 196.242 387.368 192.968V25.2593C387.368 21.8855 385.986 18.7624 383.654 16.252L383.176 16.6419L263.121 105.183ZM14.4866 199.492L132.443 105.131L14.8248 18.2055C13.4273 20.3141 12.6316 22.717 12.6316 25.2593V192.968C12.6316 195.299 13.298 197.515 14.4866 199.492ZM24.1045 11.3426L197.76 139.676L372.877 10.527C371.45 10.2525 369.958 10.1053 368.426 10.1053H31.5741C28.9284 10.1053 26.4021 10.5469 24.1045 11.3426Z"
      fill={color || '#000'}
    />
  </svg>
)

export default EmailIcon
